module.exports = __webpack_public_path__ + "static/img/storeImg@2x.6b12772.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/storeImg@2x.png
// module id = Hb0y
// module chunks = 12